import * as React from "react";
import type { SVGProps } from "react";
const SvgHeartsLoveRomance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.61 4.22c-2.32-1.75-5.51-1.54-7.6.32a6 6 0 0 0-8.31.27c-2.31 2.37-2.25 6.18.11 8.48l7.5 7.43c.19.19.45.29.7.29s.51-.1.7-.29l1.3-1.29 1.27 1.28a1 1 0 0 0 1.42.01l4.2-4.23a3.82 3.82 0 0 0 .44-4.8c1.28-2.56.6-5.71-1.74-7.47zm-7.6 14.38-6.8-6.74a4.01 4.01 0 0 1-.08-5.66 4.017 4.017 0 0 1 5.66-.08q.225.225.42.48a1 1 0 0 0 1.6 0 4.01 4.01 0 0 1 5.6-.8 3.99 3.99 0 0 1 1.36 4.53c-.47-.21-.97-.33-1.5-.33-.84.01-1.59.25-2.26.74-1.46-1.09-3.54-.98-4.91.37-1.46 1.47-1.46 3.87 0 5.35l1.51 1.53-.6.6zm7.48-3.52L16 18.59l-1.25-1.26s0-.02-.01-.02c0 0-.02 0-.02-.01l-2.19-2.22c-.69-.7-.69-1.84.02-2.56.34-.33.78-.5 1.23-.5s.9.17 1.25.52l.28.28a1 1 0 0 0 .71.3c.24-.02.52-.11.71-.29l.3-.3c.33-.33.79-.47 1.24-.5.47 0 .9.19 1.23.52.69.7.69 1.84 0 2.54z"
    />
  </svg>
);
export default SvgHeartsLoveRomance;
